import projection from '../generated/pwd5m3f1.json';
import { AcceptanceManifest } from '../types';
export const pwd5m3f1AcceptanceManifest = projection as AcceptanceManifest;
